import { Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { SectionFAQAttributes } from 'core/flow/entities';
import {
  AnswerStyled,
  ContentWrapperStyled,
  ItemImageStyled,
  ItemStyled,
  ListStyled,
  TypographyStyled,
} from './styled';

type FAQProps = {
  content: SectionFAQAttributes['content'];
};

export const FAQ = ({ content }: FAQProps) => {
  return (
    <>
      <TypographyStyled variant="h1" dangerouslySetInnerHTML={prepareHtml(content.title)} />
      <ListStyled spacing={10}>
        {content.list.map(({ question, answer, image }) => (
          <ItemStyled key={question}>
            <ContentWrapperStyled>
              <ItemImageStyled src={image.src} alt={image.alt} width={24} height={24} />
              <Typography
                variant="bodyLargeSemiBold"
                dangerouslySetInnerHTML={prepareHtml(question)}
              />
            </ContentWrapperStyled>
            <AnswerStyled
              variant="bodyMediumRegular"
              dangerouslySetInnerHTML={prepareHtml(answer)}
            />
          </ItemStyled>
        ))}
      </ListStyled>
    </>
  );
};
